/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedAffirm_user$ref = any;
export type PdpSharedAffirm_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": PdpSharedAffirm_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedAffirm_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'f766fc980b367d06ca28b8563eecaa23';
export default node;
